// removed by extract-text-webpack-plugin
module.exports = {"container":"_1krvSYC0CDy3cl-g85qHKd","marketcode":"_1z9QXp6_SoZvK-JlvfYvoy","currencyname":"_1ysIAr89rQVTB8tZCtCLlS"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Desktop/Name/styles.css
// module id = 1604
// module chunks = 85